import { Phone, MessageCircle, Mail, Instagram, Facebook, MapPin } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "./Reveal";
import { waLink } from "../../lib/api";

export function ContactsSection({ settings }) {
  if (!settings) return null;
  const cards = [
    settings.phone && {
      id: "phone", icon: Phone, label: "Telefono", value: settings.phone,
      href: `tel:${settings.phone.replace(/\s/g, "")}`, testid: "contact-phone-link",
    },
    settings.whatsapp && {
      id: "whatsapp", icon: MessageCircle, label: "WhatsApp", value: settings.whatsapp,
      href: waLink(settings.whatsapp, "Ciao Red Stone!"), testid: "contact-whatsapp-link",
    },
    settings.email && {
      id: "email", icon: Mail, label: "Email", value: settings.email,
      href: `mailto:${settings.email}`, testid: "contact-email-link",
    },
    settings.instagram && {
      id: "instagram", icon: Instagram, label: "Instagram", value: "Seguici su Instagram",
      href: settings.instagram, testid: "contact-instagram-link",
    },
    settings.facebook && {
      id: "facebook", icon: Facebook, label: "Facebook", value: "Seguici su Facebook",
      href: settings.facebook, testid: "contact-facebook-link",
    },
    settings.address && {
      id: "address", icon: MapPin, label: "Indirizzo", value: `${settings.address}, ${settings.city}`,
      href: `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(settings.maps_query || "Red Stone Ceccano")}`,
      testid: "contact-address-link",
    },
  ].filter(Boolean);

  return (
    <section id="contatti" className="py-24 sm:py-32" data-testid="contacts-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <Eyebrow>Contatti</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-4 flex flex-wrap items-end justify-between gap-6">
            <SectionTitle>
              Passa a trovarci, <em className="italic text-gold-glow">o scrivici</em>
            </SectionTitle>
            {settings.whatsapp && (
              <a
                href={waLink(settings.whatsapp, "Ciao Red Stone! Vorrei qualche informazione.")}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contacts-whatsapp-cta"
                className="inline-flex items-center gap-2 bg-burgundy-brand hover:bg-burgundy-glow text-cream text-xs font-bold uppercase tracking-[0.2em] px-7 py-3.5 rounded-full border border-gold/30 transition-colors"
              >
                <MessageCircle className="w-4 h-4" /> Scrivici su WhatsApp
              </a>
            )}
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-3 gap-4">
          {cards.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.06}>
              <a
                href={c.href}
                target={c.id === "phone" || c.id === "email" ? undefined : "_blank"}
                rel="noopener noreferrer"
                data-testid={c.testid}
                className="group block h-full bg-card2 border border-white/10 hover:border-gold/35 rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1"
              >
                <c.icon className="w-6 h-6 text-burgundy-glow group-hover:text-gold-glow transition-colors" />
                <p className="mt-4 text-[10px] font-bold uppercase tracking-[0.25em] text-cream-subtle">{c.label}</p>
                <p className="mt-1.5 text-sm sm:text-base text-cream break-words">{c.value}</p>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
